export default __webpack_public_path__ + "30befd1caf.ttf";